import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/FeaturesPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/features'

const RouteFeatures = props => (
  <Fragment>
    <h3>Feature Flags</h3>
    <PaginatedConnectionTable {...props} fields={fields} />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'features'
})(RouteFeatures)



// WEBPACK FOOTER //
// ./src/routes/admin/features/index.js